module.exports = __webpack_public_path__ + "static/media/oberflex-aulne-2560x1440.a2cbfa31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aulne-2560x1440.jpg
// module id = 981
// module chunks = 37